<template>
  <v-toolbar dense color="#dfdfdf" elevation="0" class="ma-0 pa-0">

    <div class="toolbar-buttons">
      <div class="toolbar-buttons-inner">
          <div>
            <v-text-field v-model="quicksearch" filled  dense hide-details label="Quick Search" prepend-inner-icon="search"></v-text-field>
            </div>
             <div>
             <v-autocomplete
             prepend-inner-icon="person"
                v-model="foreman_filter"
                :items="unique_users"
                item-text="Name_Concatenate"
                item-value="ID"
                hide-details
                return-object
                dense
                filled
                
                multiple
                small-chips
                deletable-chips
                label="Filter Foreman"
                elevation="0"
              clearable
                > 
                </v-autocomplete>
                </div>
            <div>
                <v-autocomplete
                prepend-inner-icon="supervised_user_circle"
                v-model="department_filter"
                :items="unique_departments"
              
                item-text="Department_Name"
                item-value="ID"
              hide-details
                return-object
                dense
                filled
                chips
                multiple
                small-chips
                deletable-chips
                label="Filter Department"
                elevation="0"
                clearable
                > 
                </v-autocomplete>
                </div>


            
                        <div>
                <v-autocomplete
                prepend-inner-icon="event_available"
                v-model="status_filter"
                :items="['Not Started','In Progress','Ready to Review','Complete']"
            
              hide-details
    
                dense
                filled
                chips
                multiple
                small-chips
                deletable-chips
                label="Filter Status"
                elevation="0"
                clearable
                > 
                </v-autocomplete>
                </div>

                <div>
                <v-autocomplete
                prepend-inner-icon="label"
                v-model="label_filter"
                :items="allLabels"
            
              hide-details
    
                dense
                filled
                chips
                multiple
                small-chips
                deletable-chips
                label="Filter Labels"
                elevation="0"
                clearable
                > 
                </v-autocomplete>
                </div>


      <div>   
       <v-select
       prepend-inner-icon="category"
        v-model="groupBy"
        :items="['Schedule Date','Department','Foreman','Status']"
        label="Group By"
        hide-details
        dense
        filled
        
      ></v-select>
      </div>
      <div class="d-flex align-center mx-2 pr-4">
      <v-switch
      v-model="show_labels"
      :label="'Show Labels'"
      hide-details=""
      dense
      class="mr-3"
    ></v-switch>

          <v-switch
      v-model="show_grid"
      :label="'Show Grid'"
      hide-details=""
      dense
    ></v-switch>

    
    </div>
    <!-- <div class="d-flex align-center pr-2"><v-btn small v-on:click="goToToday" dense solo>Today</v-btn></div> -->
      </div>
    </div>
    
      <Modifications></Modifications>
    
  </v-toolbar>
</template>

<script>
import Modifications from './Modifications';
// import Toolbar from './Toolbar';
// import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
// import { mapActions } from 'vuex'
// import { mapMutations } from 'vuex'
import { mapFields } from 'vuex-map-fields';


  export default {
    name: 'Toolbar',
    components: {
      Modifications
    },
    data: () => ({
  
    }),
    methods: {

    },
    computed: {
        ...mapFields(['groupBy','show_labels','foreman_filter','users','department_filter','departments','show_grid','quicksearch','status_filter','label_filter']),
        ...mapGetters(['unique_users','unique_departments','allLabels'])
    }
  }
</script>

<style>
.toolbar-buttons{
  width:100%;
  display:flex;
  justify-content: flex-start;

}
.toolbar-buttons-inner{
  display:flex;
}
.toolbar-buttons-inner>div{
  border-right: solid 1px #c4c4c4;
}
.toolbar-buttons label{
  font-size:.8em;

}
.toolbar-buttons .v-select__selection{
  font-size: .8em;
  font-weight: bold;
}
</style>

<style scroped>
i{
  margin-right: 10px;
}
.v-toolbar__content{
  padding: 0px !important;
}
</style>